import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { TranslationContext } from '../../../assets/contexts/translationContext';
import ScreenHeader from '../../ScreenHeader/ScreenHeader';
import BottomActionButton from '../../shared/BottomActionButton/BottomActionButton';
import './OnboardingFeesLimits.css';

function FeeSection({ title, items }) {
  return (
    <div className="onboarding-fees__section">
      <h2 className="onboarding-fees__section-title">{title}</h2>
      <ul className="onboarding-fees__list">
        {items.map(({ label, value, highlight }) => (
          <li key={label} className="onboarding-fees__item">
            <span className="onboarding-fees__label">{label}</span>
            <span
              className={`onboarding-fees__value${
                highlight ? ' onboarding-fees__value--highlight' : ''
              }`}
            >
              {value}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

function OnboardingFeesLimits() {
  const navigate = useNavigate();
  const { common, onboarding } = useContext(TranslationContext);
  const deposits = [
    { label: onboarding.usdtTopUp, value: onboarding.free, highlight: true },
    { label: onboarding.minimumTopUp, value: '1 USDT', highlight: false },
  ];
  const card = [
    { label: onboarding.virtualCardIssuance, value: onboarding.free, highlight: true },
    { label: onboarding.cardPayments, value: onboarding.noFee, highlight: true },
  ];

  const goBack = () => navigate('/onboarding/terms');

  return (
    <section className="onboarding-fees">
      <ScreenHeader title={onboarding.feesLimitsTitle} onBack={goBack} />

      <div className="onboarding-fees__content">
        <FeeSection title={onboarding.topUps} items={deposits} />
        <FeeSection title={onboarding.card} items={card} />
      </div>

      <BottomActionButton className="onboarding-fees__cta" onClick={goBack}>
        {common.done}
      </BottomActionButton>
    </section>
  );
}

export default OnboardingFeesLimits;
